import React from "react";
import { connect } from "react-redux";
import { PageDisplay, Pages, SubPageDisplay, SubPages } from "../../../../../../../store/AppDisplays";
import { isRemoteLoading, ReduxState } from "../../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { Filter } from "../../../../02-pages/Filter";
import { Results } from "../../../../02-pages/Results";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { GeneralLedgers } from "../../../../../../../store/GeneralLedgers/Types";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: GeneralLedgers;
}

type Props = StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.GENERAL_LEDGER),
    results: s.prop("remote").prop(RemoteScope.GENERAL_LEDGER),
});

/**
 *
 * @param props
 */
export class GLAuditTrailComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Header
                        title={SubPageDisplay[SubPages.AUDIT_TRAIL_GL].title}
                        description={SubPageDisplay[SubPages.AUDIT_TRAIL_GL].description}
                        goBack={PageDisplay[Pages.AUDIT_TRAILS].path}
                    />
                    <Filter
                        loadingFilters={this.props.loadingFilters}
                        loadingResults={this.props.loadingResults}
                        currentPage={Pages.GENERAL_LEDGER}
                    />
                    <Results
                        results={this.props.results}
                        loadingResults={this.props.loadingResults}
                        currentPage={SubPages.AUDIT_TRAIL_GL}
                        scope={RemoteScope.GENERAL_LEDGER}
                    />
                </Container>
            </Page>
        );
    }
}

/**
 *
 */
export const GLAuditTrail = connect(
    mapStateToProps,
    {},
)(GLAuditTrailComp);
